import { StyleSheet, Platform } from 'react-native';

import cardShadow from '../../../../Common/Styles/cardShadow';

export default StyleSheet.create({
  containerStyle: {
    marginTop: Platform.OS === 'ios' ? -17 : -27,
  },
  cardStyle: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6.2,
    ...cardShadow,
  }),
  licenceCardStyle: theme => ({
    paddingVertical: 17,
    paddingHorizontal: 16,
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    ...cardShadow,
    flexDirection: 'row',
    marginTop: 18.32,
  }),
  tabsContainerStyle: {
    marginTop: 25,
    marginRight: -16.7,
    marginBottom: 12.26,
  },
});
